//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ChartLine from "./ChartLine.vue";
import ChartBar from "./ChartBar.vue";
export default {
  components: { ChartLine, ChartBar },
  data() {
    return {
      active: 1,
      active2: 2,
    };
  },
  methods: {
    onChange(index) {
      this.active = index;
    },
    onChange2(index) {
      this.active2 = index;
    },
  },
};
